import React from 'react';

const ExcelIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
            <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"/>
            <path d="M4 15l4 6"/>
            <path d="M4 21l4 -6"/>
            <path
                d="M17 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75"/>
            <path d="M11 15v6h3"/>
        </svg>
    );
};

export default ExcelIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/ExcelIcon.jsx